import { Check, FileSpreadsheet, X, Zap } from "lucide-react";

const TODAY = [
  "Planilhas e controles paralelos em que ninguém confia",
  "Sistemas genéricos que não se encaixam no seu processo",
  "Equipe presa em tarefas repetitivas",
  "IA: muita conversa e nenhuma aplicação real",
];

const WITH_VEXLY = [
  "Sistemas feitos para o jeito que a sua empresa funciona",
  "Ferramentas integradas e dados em um só lugar",
  "Operação automatizada e equipe focada no que importa",
  "IA aplicada onde gera resultado, com um plano claro",
];

const Problem = () => (
  <section className="relative overflow-hidden bg-night text-white">
    <div aria-hidden="true" className="bg-grid-dark absolute inset-0" />
    <div
      aria-hidden="true"
      className="absolute left-1/2 top-0 h-[300px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-600/40 blur-[120px]"
    />

    <div className="relative mx-auto max-w-page px-5 py-16 sm:px-8 sm:py-24 lg:py-32">
      <div className="max-w-[760px]">
        <p className="eyebrow-dark">O problema</p>
        <h2 className="section-title text-white">Sua empresa cresceu. A tecnologia não acompanhou.</h2>
        <p className="lead text-white/65">
          Planilha para tudo, sistemas que não conversam entre si e uma equipe que passa o dia apagando incêndio.
          Enquanto isso, todo mundo fala de IA, mas ninguém mostra como aplicar no seu negócio.
        </p>
      </div>

      <div className="mt-10 grid gap-5 sm:mt-14 lg:grid-cols-2">
        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 sm:p-8 lg:p-10">
          <div className="flex items-center justify-between">
            <h3 className="font-mono text-[12px] font-normal uppercase tracking-[0.16em] text-white/50">Hoje</h3>
            <FileSpreadsheet className="h-5 w-5 text-white/40" aria-hidden="true" />
          </div>
          <ul className="mt-6 space-y-4 sm:mt-8 sm:space-y-5">
            {TODAY.map((item) => (
              <li key={item} className="flex gap-4">
                <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-white/[0.08] text-white/50">
                  <X className="h-3.5 w-3.5" aria-hidden="true" />
                </span>
                <span className="text-[16px] leading-snug text-white/70 sm:text-[17px]">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="relative overflow-hidden rounded-3xl bg-brand-600 p-6 shadow-[0_30px_80px_-30px_rgb(88_50_240/.9)] sm:p-8 lg:p-10">
          <div aria-hidden="true" className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-brand-400/40 blur-3xl" />
          <div className="relative flex items-center justify-between">
            <h3 className="font-mono text-[12px] font-normal uppercase tracking-[0.16em] text-brand-100">Com a Vexly</h3>
            <Zap className="h-5 w-5 text-brand-200" aria-hidden="true" />
          </div>
          <ul className="relative mt-6 space-y-4 sm:mt-8 sm:space-y-5">
            {WITH_VEXLY.map((item) => (
              <li key={item} className="flex gap-4">
                <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-white/15">
                  <Check className="h-3.5 w-3.5" aria-hidden="true" />
                </span>
                <span className="text-[16px] leading-snug sm:text-[17px]">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Problem;
